import styled from 'styled-components';
import { Button } from 'client/widgets/ui';
import theme from 'client/widgets/lib/theme';

const Form = styled.form
  .withConfig({
    shouldForwardProp: (props) => {
      return !['show'].includes(props);
    },
  })
  .attrs((props) => {
    return {
      className: props.show ? '' : '_hide',
    };
  })`
  font-size: var(--fs-md);
  color: #fff;
  width: 312px;
  margin: 0 auto;
  padding-top: 40px;
  &._hide {
    display: none;
  }

  .desc {
    color: #c3c3c3;
    font-size: var(--fs-base);
    padding: 10px 0;
    white-space: nowrap;
    margin-bottom: -10px;
    line-height: 24px;
  }
  .desc a {
    color: #c3c3c3;
    &:hover {
      text-decoration: underline;
    }
  }
`;
const FormItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & + & {
    margin-top: 12px;
  }
  .blank {
    flex: auto;
    width: 1px;
  }
`;

const Input = styled.input`
  //border: 1px solid #cccccc;
  box-sizing: border-box;
  border-radius: 100px;
  height: 40px;
  background: #454d56;
  font-size: var(--fs-md);
  padding: 0 20px;
  flex: auto;
  &:focus {
    border-color: #333;
  }
`;

const FormTip = styled.div`
  color: #ff3b30;
  font-size: var(--fs-base);
  padding: 8px 0 8px 20px;
  height: 20px;
`;

const Radio = styled.div.attrs((props) => {
  return {
    className: props.$check ? 'check' : '',
  };
})`
  display: inline-flex;
  align-items: center;
  vertical-align: top;
  cursor: pointer;
  .iconfont,
  span {
    display: inline-block;
    vertical-align: top;
  }
  &.check {
    .iconfont {
      color: ${theme.color.primary};
    }
  }
  margin-right: 14px;
`;

export default {
  Form,
  FormItem,
  Input,
  FormTip,
  Radio,
};
